module.exports = __webpack_public_path__ + "img/visa.28338b4f.jpg";